type Verification = {
  email?: boolean;
  phone?: boolean;
  bank?: boolean;
};

type VerificationsProps = {
  verifications?: Verification;
  showModal?: boolean;
};

type VerificationType = 'Email' | 'Phone' | 'Payment card';

export const VerificationStatus = {
  NotVerified: 'not-verified',
  BasicVerified: 'basic-verified',
  PartialVerified: 'partial-verified',
  FullyVerified: 'fully-verified',
} as const;

type VerificationStatusType =
  (typeof VerificationStatus)[keyof typeof VerificationStatus];

interface VerificationDetails {
  iconStatus: VerificationStatusType;
  statusText: string;
}

export type {
  Verification,
  VerificationsProps,
  VerificationDetails,
  VerificationType,
  VerificationStatusType,
};
